import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { Card } from '../../atoms/Card';
import { Typography } from '../../atoms/Typography';
import { ChevronRight } from '../../icons/ChevronRight';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    color: theme.palette.primary.main,
  },
  root: {
    display: 'flex',
    flex: 1,

    '& .MuiCardActionArea-root': {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
    },
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(14),
    marginRight: theme.spacing(1),
  },
}));

export type Props = {
  onClick: () => void;
  title: string;
};

export function ButtonCard(props: Props): JSX.Element {
  const { onClick, title } = props;
  const classes = useStyles();

  const rootStyle = clsx('fd-button-card', classes.root);

  return (
    <Card className={rootStyle} data-fd="button-card" onClick={onClick}>
      <Typography className={classes.title}>{title}</Typography>
      <ChevronRight size="xs" className={classes.icon} />
    </Card>
  );
}
